import Backbone from 'backbone'
import _ from 'lodash'
import $ from 'jquery'
import * as websocket from '../../components/websocket'

let deferred = $.Deferred()
const status = new DatasetStatus()
/**
 * A singleton for the entire scoreboard client that listens for dataset status
 * updates. Only the most recent status is kept for each dataset root id.
 *
 * @emits change provides listeners with a dataset root id that received a new status.
 * function argument includes: {id, status, progress}
 *
 * @returns {Function} A function that returns a promise, which is fulfilled
 * with this DatasetStatus instance once the websocket has been (re)established.
 */
function DatasetStatus() {

	// {dataset.rootId : {id, status, progress}, ... }
	this.statusByDataset = {}

	// #20518 can't do this until we're logged into a database
	Backbone.once('load:database', databaseId => {
		websocket.latest().then(subscribeNotifications.bind(this, databaseId))
		Backbone.on('websocket:reconnect', stompClient => {
			deferred = $.Deferred()
			subscribeNotifications.call(this, databaseId, stompClient)
		})
	})
}

// The properties that the websocket connection sends which will be available through datasetStatus()
const WEBSOCKET_STATUS_PROPERTIES = [
	'id',
	'status',
	'progress',
	'errorCode',
	'errorArguments',
	'numTracked',
	'fieldErrorsById',
	'stackTrace',
	'lastImportTime',
	'numRows',
	'lastFileEmpty'
]

function subscribeNotifications(databaseId, stompClient) {
	let url = `/topic/database/${databaseId}/datasetstatus`
	stompClient.subscribe(url, (message) => {
		// e.g. { id: 1, status: 'loading', progress: .5 }
		const messageBody = JSON.parse(message.body)
		const id = messageBody.id
		console.dir(message.body)
		this.statusByDataset[id] = {}
		_.forEach(WEBSOCKET_STATUS_PROPERTIES, prop =>
			this.statusByDataset[id][prop] = messageBody[prop])
		// remove the undefined keys
		this.statusByDataset[id] =
			_.pickBy(this.statusByDataset[id], it => it !== undefined)
		this.trigger('change', this.statusByDataset[id])
	})
	stompClient.subscribe(`${url}/reset`, message => {
		const {body} = message
		let ids = []
		if (_.size(body) > 0) {
			ids = JSON.parse(body)
		}
		if (_.isEmpty(ids)) {
			this.reset()
		} else {
			_.each(ids, id => this.resetDataset(id))
		}
	})
	deferred.resolve(status)
}

_.extend(DatasetStatus.prototype, Backbone.Events, {

	/**
	 * If an operation occurs that requires all datasets to be rebuilt the client
	 * must purge it's cache, this function does that.
	 */
	reset() {
		this.statusByDataset = {}
	},

	/**
	 * Allow a dataset status to be purged when a dataset is updated so current status comes from dataset
	 * before a websocket push is received. (#19824)
	 */
	resetDataset(datasetRootId) {
		delete this.statusByDataset[datasetRootId]
	},

	/**
	 * Should be invoked in response to notification of a change event, OR
	 * when a view initially loads and needs to know if there was a new status
	 * sent by the server.
	 *
	 * @param {Number} datasetRootId
	 * @return {id, status, progress} or undefined if no status was pushed
	 */
	get: function(datasetRootId) {
		let statusObj
		const lastStatusUpdate = this.statusByDataset[datasetRootId]
		if (lastStatusUpdate) {
			statusObj = lastStatusUpdate
		}
		return statusObj
	}
})

/**
 * The deferred object can be reinstantiated if a connection is reset
 * (e.g. due to impersonation) so this must be a function that always returns
 * the most current instance.
 */
function datasetStatus() {
	return deferred
}
export default datasetStatus

datasetStatus.__filename__ = 'datasets/not-available/dataset-status.js'
